import { TextRange } from 'src/graphql';
import { removeOverlapFromDeletedText } from './removeOverlapFromDeletedText';

export const getDeletedTextListFromString = (
  deletedText: TextRange[],
  stringToRedact: string,
): string[] => {
  if (!stringToRedact || !deletedText.length) {
    return [];
  }
  const condensedDeletedText = removeOverlapFromDeletedText(deletedText);

  const trimmedText = stringToRedact.trim();
  const deletedStrings = condensedDeletedText.map(({ offset, length }) =>
    trimmedText.slice(offset, offset + length),
  );
  return deletedStrings;
};
